import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    getAlGroupsForDropdown,
    getOperationEntityByGroup,
    getAllRoutesByFactoryID,
    getEmployeeTypesData,
    getHaverstingJobTypeByEmployeeTypeID,
    createQRtag,
    saveQRtags
};

async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getEmployeeTypesData() {
    var response = await CommonGet('/api/EnumData/GetEmployeeTypeEnumData', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}

async function getHaverstingJobTypeByEmployeeTypeID(employeeTypeID) {
    var response = await CommonGet('/api/HaverstingJobType/GetHaverstingJobTypeByEmployeeTypeID', 'employeeTypeID=' + employeeTypeID);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["haverstingJobTypeID"]] = item[1]["haverstingJobTypeName"]
    }
    return array;
}

async function createQRtag(model) {
    const response = await CommonPost('/api/TagGeneration/CreateTag', null, model);
    return response.data;
}

async function saveQRtags(data) {
    const response = await CommonPost('/api/TagGeneration/SaveTag', null, data);
    return response;
}

async function getOperationEntityByGroup(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}

async function getAllRoutesByFactoryID(estateID) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + estateID);
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]

    }
    return divisionArray;
}